export const EventStatus = {
	EMITTED: "EMITTED",
	PROCESSING: "PROCESSING",
	RECORDING: "RECORDING",
	COMPLETED: "COMPLETED",
	FAILED: "FAILED",
};
